import script from "./FormDropFile.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDropFile.vue?vue&type=script&setup=true&lang=js"

import "./FormDropFile.vue?vue&type=style&index=0&id=7cfa5066&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cfa5066"]])

export default __exports__